<template>
  <div id="app">
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      imagePath: require('@/assets/img/footer-logo-temp.png'),
    };
  },
  methods: {
  },
  created() {
    var isIE = /*@cc_on!@*/false || !!document.documentMode;
    if(isIE){
      this.$router.push({path: "/browser-warning"});
    }
  }
};
</script>

<style>
@import "components/view/css/footer.css";
@import "components/view/css/customNavBar.css";

/*for table item align center*/
.table-label-class {
  text-align: center;
}

.table-key-header{
  font-weight: bold;
  font-style: italic;
  color: black;
}

.table-black-header{
  color: black;
  font-weight: bold;
}

.table-black-content{
  color: black;
  font-weight: bold;
}

.el-table .success-row {
  background: #FFFFCC !important;
}

.el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: initial !important;
}

.is-disabled .el-input__inner  {
  color: #606266 !important;
}

/*element ui table width bug for e check list*/
td.el-table_11_column_1 {
  width: 80px !important;
}
td.el-table_11_column_2 {
  width: 80px !important;
}
td.el-table_11_column_3 {
  width: 250px !important;
}
td.el-table_11_column_4 {
  width: 100px !important;
}
td.el-table_11_column_5 {
  min-width: 100px !important;
}
td.el-table_11_column_6 {
  width: 100px !important;
}
td.el-table_11_column_7 {
  min-width: 100px !important;
}
</style>
